// extracted by css-extract-rspack-plugin
export default {"badge":"_1668337b","dot":"_27bba241","smallDot":"_ec1c0dfe"};